export const patientMaxHR = {
  computed: {
    age() {
      if (!this.patient || !this.patient.birth_date) {
        return null
      }
      return this.moment().diff(this.moment(this.patient.birth_date), 'years')
    },
    maxHr() {
      if (!this.age) {
        return 0
      }
      return Math.round(208 - 0.7 * this.age)
    }
  }
}
